import { render, staticRenderFns } from "./Upload.vue?vue&type=template&id=761bfdc2&scoped=true&"
import script from "./Upload.vue?vue&type=script&lang=ts&"
export * from "./Upload.vue?vue&type=script&lang=ts&"
import style0 from "./Upload.vue?vue&type=style&index=0&id=761bfdc2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761bfdc2",
  null
  
)

export default component.exports